"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "next/navigation";
import { FacebookIcon, FacebookShareButton, TwitterShareButton, XIcon } from "react-share";
const size = 45;
export interface SocialMediaShareProps {
  title: string;
}
export default function SocialMediaShare(t0) {
  const $ = _c(11);
  const {
    title
  } = t0;
  const pathname = usePathname();
  const path = (process.env.NEXT_PUBLIC_BASE_PATH ?? "https://partiguiden.nu") + (pathname ?? "/");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <FacebookIcon size={size} round={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== path || $[2] !== title) {
    t2 = <FacebookShareButton url={path} title={title}>{t1}</FacebookShareButton>;
    $[1] = path;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <XIcon size={size} round={true} />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== path || $[6] !== title) {
    t4 = <TwitterShareButton url={path} title={title}>{t3}</TwitterShareButton>;
    $[5] = path;
    $[6] = title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="flex justify-end gap-2">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}